export var inputSectionLss = {
    mt: 'md',
    flexDirection: 'column',
    alignItems: 'flex-start',
    tablet: { flexDirection: 'row', alignItems: 'flex-end' }
};
export var leftInputLss = {
    flexDirection: 'column',
    mb: 'sm',
    tablet: { mb: 'none' }
};
export var labelLss = { mb: 'xxs', textScale: 'caption' };
export var getSliderWrapperLss = function () { return ({
    py: 'sm',
    position: 'relative',
    width: '100%',
    ml: 'none'
}); };
//# sourceMappingURL=styles.js.map